import { useEffect, useRef, useState } from 'react'
import Header from '../../components/Layout/Header'
import Footer from '../../components/Layout/Footer'
import { useDispatch, useSelector } from 'react-redux'
import { NotificationGetAction } from '../../redux/Action/NotificationAction'
import moment from 'moment'
import Spinner from '../../components/Spinner'
import { localTimezone, timeAgo } from '../../utils/Helper'
 import { ImageContainer } from '../../constants/ImagesConstants'
import { FormattedMessage } from 'react-intl'

const Notification = () => {
  const dispatch = useDispatch<any>();
  const profileData = useSelector((state: any) => state.GetProfileState);
  const notification_data = useSelector((state: any) => state.NotificationGetState);
  const [groupedNotifications, setGroupedNotifications]: any = useState({});
  const [data, setData]: any = useState([]);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const containerRef: any = useRef(null);
  const scrollDivRef: any = useRef(null);


  moment.locale('en');

  const payload = {
    name: profileData?.data?.data?.salon_name, email: profileData?.data?.data?.email, image: profileData?.data?.data?.buisness_images?.[0]?.file_path
  }

  // useEffect(() => {
  //   dispatch(NotificationGetAction({}))
  // }, []);
  useEffect(() => {
    const fetchData = async () => {
      if (page != 0) {
        setIsLoading(true);
      }

      dispatch(NotificationGetAction({ page, pageSize: 20 }))
      // dispatch(NotificationGetAction({ page, status, pageSize: 5 }))
    };
    fetchData();
  }, [page, dispatch,]);




  useEffect(() => {
    if (notification_data?.status && notification_data?.loading === false) {
      if (page === 0) {
        setData(notification_data?.data?.data?.rows);
      } else {
        setData([...data, ...notification_data?.data?.data?.rows]);
      }
      setIsLoading(false);
    }

  }, [notification_data])


  useEffect(() => {
    if (data) {
      const grouped = data?.reduce((acc: any, notification: any) => {
        const date = moment(notification.created_at).format('D MMMM YYYY');
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(notification);
        return acc;
      }, {});
      setGroupedNotifications(grouped);
    }
  }, [notification_data, data]);


  const [className, setClassName] = useState('hide')
  const [expanded, setExpanded] = useState<{ [key: string]: boolean }>({});


  const handleChangeClass = (id: string) => {
    setExpanded(prevState => ({
      ...prevState,
      [id]: !prevState[id]
    }));
  };
  const isExpanded = (id: string) => expanded[id] || false;




  useEffect(() => {
    const totalPages = Math.ceil(notification_data?.data?.data?.count / 10+1);
      if (page < totalPages) {
      window.addEventListener('scroll', handleScroll);
    }
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [notification_data, isLoading]);

  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = window.innerHeight;

    if (Math.round((scrollTop + clientHeight) * 100 / scrollHeight) === 100 && !isLoading) {
      setIsLoading(true);
      setPage(page + 1);
    }
  };


  return (
    <>
      <Header payload={payload} />
      <main>
        {notification_data?.loading ? <Spinner /> : ""}
        <div className='container pb-5'>
          <h1 className='title mb-4'><FormattedMessage id="notification" /></h1>
          {
            data?.length > 0 ? (
              <>
                <div className='row notify-scroll' ref={scrollDivRef} onScroll={handleScroll}>

                  {
                    Object.keys(groupedNotifications)?.map((item: any) => {
                      return (
                        <>
                          <div className='col-md-12' key={item} >
                            <p className='notification-Date'>{item}</p>
                            <ul className='notificatiolList'>
                              {
                                groupedNotifications[item].map((notification: any) => {
                                  const bodyText = notification?.notification_params?.body ?? "";
                                  const isLongText = bodyText.length > 50;
                                  const notificationId = notification?.id; // Assuming each notification

                                  return (
                                    <>
                                      <li key={notificationId}>
                                        <figure><img src={notification?.notification_params?.image?.length > 0 ? notification?.notification_params?.image : ImageContainer?.USERIMAGE}
                                        // onError={(e: any) => e.target.src = ImageContainer?.USERIMAGE} 
                                        /></figure>
                                        <div>

                                          <p className='notTitle'>{notification?.notification_params?.title ? notification?.notification_params?.title : ""}</p>

                                          {/* <div className='d-flex'>
                                            <p className={className}>{notification?.notification_params?.body ? notification?.notification_params?.body : ""}</p>
                                            <span onClick={handleChangeClass} className="moreless-button">
                                              {className == "show" ? 'Read less' : 'Read more'}
                                            </span>
                                          </div> */}

                                          <div className='d-flex'>
                                            <p className={isExpanded(notificationId) ? 'show' : 'hide'}>
                                              {isExpanded(notificationId) || !isLongText
                                                ? bodyText
                                                : `${bodyText.substring(0, 50)}...`}
                                            </p>
                                            {isLongText && (
                                              <span
                                                onClick={() => handleChangeClass(notificationId)}
                                                className="moreless-button"
                                              >
                                                {isExpanded(notificationId) ? 'Read less' : 'Read more'}
                                              </span>
                                            )}
                                          </div>

                                          <p className='notDate'>{localTimezone(notification?.created_at)}</p>
                                        </div>
                                      </li>
                                    </>
                                  )
                                })
                              }
                            </ul>
                          </div>
                        </>
                      )
                    })
                  }
                </div>
              </>
            ) : <p> <FormattedMessage id="notification_message" /></p>
          }


        </div>
      </main>
      <Footer />
    </>
  )
}

export default Notification


/*
import { useEffect, useRef, useState } from 'react'
import Header from '../../components/Layout/Header'
import Footer from '../../components/Layout/Footer'
import { useDispatch, useSelector } from 'react-redux'
import { NotificationGetAction } from '../../redux/Action/NotificationAction'
import moment from 'moment'
import Spinner from '../../components/Spinner'
import { localTimezone, timeAgo } from '../../utils/Helper'
import $ from "jquery";
import { ImageContainer } from '../../constants/ImagesConstants'

const Notification = () => {
  const dispatch = useDispatch<any>();
  const profileData = useSelector((state: any) => state.GetProfileState);
  const notification_data = useSelector((state: any) => state.NotificationGetState);
  const [groupedNotifications, setGroupedNotifications]: any = useState({});
  const [data, setData]: any = useState([]);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const containerRef: any = useRef(null);
  const scrollDivRef: any = useRef(null);



  const handleScroll = () => {
    if (page <= (notification_data?.data?.data?.count * (page + 1)) / 10) {
      const div = scrollDivRef?.current;
      if (div && !isLoading) {
        const { scrollTop, scrollHeight, clientHeight } = div;
        if ((Math.round((scrollTop + clientHeight) * 100 / scrollHeight) === 100) && !isLoading) {
          setIsLoading(true)
          setPage(page + 1);
        }
      }
    }
  };

  moment.locale('en');

  const payload = {
    name: profileData?.data?.data?.salon_name, email: profileData?.data?.data?.email, image: profileData?.data?.data?.buisness_images?.[0]?.file_path
  }

  // useEffect(() => {
  //   dispatch(NotificationGetAction({}))
  // }, []);
  useEffect(() => {
    const fetchData = async () => {
      if (page != 0) {
        setIsLoading(true);
      }

      dispatch(NotificationGetAction({ page, status, pageSize: 20 }))
    };
    fetchData();
  }, [page, dispatch,]);


  useEffect(() => {
    if (notification_data?.data?.data?.rows) {
      setData(notification_data?.data?.data?.rows)
    }
  }, [notification_data]);


  useEffect(() => {
    if (data) {
      const grouped = data?.reduce((acc: any, notification: any) => {
        const date = moment(notification.created_at).format('D MMMM YYYY');
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(notification);
        return acc;
      }, {});
      setGroupedNotifications(grouped);
    }
  }, [notification_data, data]);






  return (
    <>
      <Header payload={payload} />
      {notification_data?.loading ? <Spinner /> : ""}
      <div className='container pb-5'>
        <h1 className='title mb-4'>Notification</h1>
        {
          data?.length > 0 ? (
            <>
              <div className='row notify-scroll' ref={scrollDivRef} onScroll={handleScroll}>

                {
                  Object.keys(groupedNotifications)?.map((item: any) => {

                    return (
                      <>
                        <div className='col-md-12' key={item} >
                          <p className='notification-Date'>{item}</p>
                          <ul className='notificatiolList'>
                            {
                              groupedNotifications[item].map((notification: any) => {
                                 return (
                                  <>
                                    <li>
                                      <figure><img src={notification?.notification?.[0]?.notification_params?.image?.length > 0 ? notification?.notification?.[0]?.notification_params?.image : ImageContainer?.USERIMAGE}
                                        onError={(e: any) => e.target.src = ImageContainer?.USERIMAGE}
                                      /></figure>
                                      <div>
                                        <p className='notTitle'>{notification?.notification?.[0]?.notification_params?.title ? notification?.notification?.[0]?.notification_params?.title : ""}</p>
                                        <p>{notification?.notification?.[0]?.notification_params?.body ? notification?.notification?.[0]?.notification_params?.body : ""}</p>
                                        <p className='notDate'>{localTimezone(notification?.created_at)}</p>
                                      </div>
                                    </li>
                                  </>
                                )
                              })
                            }
                          </ul>
                        </div>
                      </>
                    )
                  })
                }
              </div>
            </>
          ) : <p> No new notifications available</p>
        }


      </div>
      <Footer />
    </>
  )
}

export default Notification
*/